let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

//注册回调函数,第一次连接时调用 初始化函数(android需要初始化,ios不用)
setupWebViewJavascriptBridge(function (bridge) {
    if (isAndroid) {
        //初始化
        console.log('是否到这块')
        // bridge.init(function (message, responseCallback) {
        //     console.log(message, '初始化')
        //     var data = {
        //         'Javascript Responds': 'Wee!'
        //     };
        //     responseCallback(data);
        // })
    }
})


//这是必须要写的,用来创建一些设置
function setupWebViewJavascriptBridge(callback) {
    //Android使用
    if (isAndroid) {
        if (window.WebViewJavascriptBridge) {
            return callback(WebViewJavascriptBridge);
        }
        if (window.WVJBCallbacks) {
            return window.WVJBCallbacks.push(callback);
        }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () {
            document.documentElement.removeChild(WVJBIframe)
        }, 0);
        console.log('tag', '安卓')
        sessionStorage.phoneType = 'android'
    }

    //iOS使用WKUserContentController
    if (isiOS) {
        if (window.webkit && window.webkit.messageHandlers) {
            sessionStorage.phoneType = 'ios';
            return callback({
                callHandler: function (name, data, responseCallback) {
                    if (window.webkit.messageHandlers[name]) {
                        var timeStamp = new Date().getTime();
                        window.webkit.messageHandlers[name].postMessage({
                            data: data,
                            callbackId: 'callback_' + timeStamp
                        });
                        // 存储回调函数,供原生代码稍后调用
                        window['callback_' + timeStamp] = responseCallback;
                    } else {
                        console.error('iOS handler not found:', name);
                    }
                },
                registerHandler: function (name, handler) {
                    // 注册供原生调用的JS处理函数
                    window[name] = handler;
                }
            });
        } else {
            console.error('iOS bridge is not available');
        }
    }
}


export default {
    // js调APP方法 (参数分别为:app提供的方法名  传给app的数据  回调)
    callHandler(name, data, callback) {
        console.log("callHandler",name)
        console.log("callHandler",data)
        setupWebViewJavascriptBridge(function (bridge) {
            console.log("callHandler",name)
            bridge.callHandler(name, data, callback)
        })
    },
    // APP调js方法 (参数分别为:js提供的方法名  回调)
    registerHandler(name, callback) {
        setupWebViewJavascriptBridge((bridge) => {
            bridge.registerHandler(name, (data, responseCallback) => {
                callback(data, responseCallback);
            });
        });
    },
}